import { Box, Chip, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import zeplinColor from '../../../../../theme/Color';
import CustomDatePicker from '../../../CustomDatePicker/CustomDatePicker';
import CustomTextField from '../../../CustomTextField/CustomTextField';

const AddProductCard = ({
  handleInputChange,
  data,
  index,
}: {
  handleInputChange: (field: string, value: any, index: any) => void;
  data?: {
    PricebookEntryId: string;
    UnitPrice: number;
    id: string;
    name: string;
    Quantity?: string;
    ServiceDate?: string;
    description?: string;
  };
  index: number;
}) => {
  const [active, setActive] = useState(false);

  return (
    <Box
      sx={{
        borderRadius: '14px',
        padding: '24px',
        backgroundColor: zeplinColor.Neutral1,
        border: `1px solid ${zeplinColor.Neutral5}`,
        boxShadow: 'rgba(0, 0, 0, 0.15)',
        '&:hover': { border: `1px solid ${zeplinColor.BasicBlack}` },
      }}
      onClick={() => {
        setActive((prev) => !prev);
      }}
    >
      {!active ? (
        <InactiveProductCard name={data?.name} UnitPrice={data?.UnitPrice} />
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px', width: '100%' }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: '24px',
              color: zeplinColor.BasicBlack,
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <Typography variant='body2'>{data?.name || 'NA'}</Typography>
              <Box sx={{ width: '100%' }}>
                <Chip
                  label={<Typography variant='label1'>{data?.name}</Typography>}
                  sx={{
                    bgcolor: zeplinColor.Neutral4,
                    color: zeplinColor.BasicBlack,
                    '&.MuiChip-root': {
                      height: '22px',
                      padding: '4px 8px',
                      borderRadius: '50px',
                    },
                    '& .MuiChip-label': {
                      padding: 0,
                      margin: 0,
                    },
                  }}
                />
              </Box>
            </Box>
            <Box onClick={(e) => e.stopPropagation()}>
              <CustomTextField
                style={{ width: '100%', flex: 1 }}
                onChange={(e) => {
                  handleInputChange('UnitPrice', e.target.value, index);
                }}
                name={'Sales price'}
                text={data?.UnitPrice ? String(data.UnitPrice) : ''}
                label={'Sales price'}
                type='number'
                tabindex={1}
              />
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: '24px' }}>
            <Box onClick={(e) => e.stopPropagation()}>
              <CustomTextField
                style={{ width: '100%' }}
                onChange={(e) => {
                  handleInputChange('Quantity', e.target.value, index);
                }}
                name={'Quantity'}
                text={data?.Quantity ? data.Quantity : ''}
                label={'Quantity'}
                type='number'
                tabindex={1}
                required
              />
            </Box>
            <Box onClick={(e) => e.stopPropagation()}>
              <CustomDatePicker
                value={dayjs(data?.ServiceDate)}
                setValue={(date) => {
                  handleInputChange(
                    'ServiceDate',
                    dayjs(date as Dayjs).format('YYYY-MM-DD'),
                    index,
                  );
                }}
                label={'Close date'}
              />
            </Box>
          </Box>
          <Box onClick={(e) => e.stopPropagation()}>
            <CustomTextField
              style={{ width: '100%' }}
              onChange={(e) => {
                handleInputChange('description', e.target.value, index);
              }}
              name='Description'
              text={data?.description ? data.description : ''}
              label={'Description'}
              type='text'
              tabindex={1}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AddProductCard;

const InactiveProductCard = ({
  name,
  UnitPrice,
}: {
  name: string | undefined;
  UnitPrice: number | undefined;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        color: zeplinColor.BasicBlack,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        <Typography variant='body2'>{name || 'NA'}</Typography>
        <Chip
          label={<Typography variant='label1'>{name}</Typography>}
          sx={{
            bgcolor: zeplinColor.Neutral4,
            color: zeplinColor.BasicBlack,
            '&.MuiChip-root': {
              height: '22px',
              padding: '4px 8px',
              borderRadius: '50px',
            },
            '& .MuiChip-label': {
              padding: 0,
            },
          }}
        />
      </Box>
      <Typography variant='body1'>${UnitPrice}</Typography>
    </Box>
  );
};
